/* tslint:disable */
/* eslint-disable */
/**
 * PR TIMES プレスリリースエディタ API
 * PR TIMES 企業管理画面 プレスリリースエディタ用の API
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetPressReleaseHistorySuccessResponsePressReleaseHistoryImages
 */
export interface GetPressReleaseHistorySuccessResponsePressReleaseHistoryImages {
    /**
     * 画像のファイル名
     * @type {string}
     * @memberof GetPressReleaseHistorySuccessResponsePressReleaseHistoryImages
     */
    fileName: string;
    /**
     * 画像のS3に保存されたファイル名
     * @type {string}
     * @memberof GetPressReleaseHistorySuccessResponsePressReleaseHistoryImages
     */
    fileNameS3: string;
}

export function GetPressReleaseHistorySuccessResponsePressReleaseHistoryImagesFromJSON(json: any): GetPressReleaseHistorySuccessResponsePressReleaseHistoryImages {
    return GetPressReleaseHistorySuccessResponsePressReleaseHistoryImagesFromJSONTyped(json, false);
}

export function GetPressReleaseHistorySuccessResponsePressReleaseHistoryImagesFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetPressReleaseHistorySuccessResponsePressReleaseHistoryImages {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'fileName': json['file_name'],
        'fileNameS3': json['file_name_s3'],
    };
}

export function GetPressReleaseHistorySuccessResponsePressReleaseHistoryImagesToJSON(value?: GetPressReleaseHistorySuccessResponsePressReleaseHistoryImages | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'file_name': value.fileName,
        'file_name_s3': value.fileNameS3,
    };
}

